import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';
import { leaseRateUnitOptions } from 'components/lease_structure/form/helpers/select_options';
import { USD } from 'helpers/formatters/number_formats';

export function LeaseRateValue({ deal }) {
  let value;
  if (deal.leaseRate) {
    value = USD.format(deal.leaseRate);

    const option = leaseRateUnitOptions(deal).find(option => option.value === deal.leaseRateUnits);
    if (option) {
      value = `${value} (${option.label})`;
    }
  }

  return <Value name="leaseRate" value={value} />;
}

LeaseRateValue.propTypes = {
  deal: PropTypes.shape({
    leaseRate: PropTypes.number,
    leaseRateUnits: PropTypes.string,
    spaceSizeUnits: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(LeaseRateValue);
